import { get, groupBy, isEqual } from 'lodash-es';
import { initialFilters } from './config';
import { usePermissions } from '@/core/shared/setup/permissions';
// timer
import moment from 'moment';

export const stationId = (state, getters, rootState, rootGetters) => {
  return rootState.route && rootState.route.params.stationId;
};
export const isFilterDirty = (state, getters) => {
  return !isEqual(state.filters, initialFilters);
};

// export const stationTagsByTags = (state, getters, rootState, rootGetters) =>
//   keyBy(state.stationTags, 'text')
export const stationTags = (state, getters, rootState, rootGetters) => {
  const ids = state.stationTagIds;
  return rootGetters['entities/StationTag'](ids);
};

export const stationTagsWithGames = (
  state,
  getters,
  rootState,
  rootGetters,
) => {
  const ids = state.stationTagIds;
  return rootGetters['entities/StationTag'](ids);
};
export const launcherStationTagsWithGames = (
  state,
  getters,
  rootState,
  rootGetters,
) => {
  const ids = state.launcherstationTagIds;
  return rootGetters['entities/StationTag'](ids);
};

export const filteredGames = (state, getters, rootState, rootGetters) => {
  const ids = state.filteredGameIds;
  return ids.reduce((result, id) => {
    const found = rootGetters['entities/Game'](id);
    return found ? [...result, found] : result;
  }, []);
};
export const searchedGames = (state, getters, rootState, rootGetters) => {
  const ids = state.searchedGameIds;
  return ids.reduce((result, id) => {
    const found = rootGetters['entities/Game'](id);
    return found ? [...result, found] : result;
  }, []);
};
export const tutorialId = (state, getters, rootState, rootGetters) => {
  return get(getters, 'currentStation.experience.tutorial.id', null);
};
export const allGames = (state, getters, rootState, rootGetters) => {
  return rootGetters['entities/Game/all']();
};
export const featuredGames = (state, getters, rootState, rootGetters) => {
  const ids = state.featuredGameIds;
  return ids.reduce((result, id) => {
    const found = rootGetters['entities/Game'](id);
    return found ? [...result, found] : result;
  }, []);
};

export const detailGame = (state, getters, rootState, rootGetters) => {
  if (!rootState.route) return;
  const gameId = rootState.route.params.gameId;
  return rootGetters['entities/Game'](gameId);
};

export const currentStation = (state, getters, rootState, rootGetters) => {
  const stationId = getters.stationId;
  if (!stationId) return;
  return rootGetters['entities/Station'](stationId);
};
export const stationOrganization = (state, getters, rootState, rootGetters) => {
  const station = getters.currentStation;
  return station && station.organization;
};

export const isGameRunning = (state, getters, rootState, rootGetters) => {
  const { runningType } = state.appState;
  return (
    runningType === 'game' ||
    runningType === 'tutorial' ||
    runningType === 'unknown_game'
  );
};

export const playingGame = (state, getters, rootState, rootGetters) => {
  if (!getters.currentStation) return;
  if (state.appState.runningType === 'launcher') {
    return getters.launcherGame;
  } else {
    return getters.currentStation.playing || getters.unknownGame;
  }
};
export const unknownGame = () => ({ id: null, title: 'Unknown game' });
export const launcherGame = (state, getters) => {
  const banners = get(getters, 'currentStation.experience.banners');
  const landscapeBanner = banners && banners.find(b => b.size === 'landscape');
  const permissions = usePermissions();
  return {
    id: null,
    title: permissions['content-only'] ? get(getters, 'currentStation.title') : get(getters, 'currentStation.location.title'),
    imageUrl: landscapeBanner && landscapeBanner.imageUrl,
  };
};

// import { banners as mockBanners } from '../../../test/unit/fixtures' // MOCK
export const banners = (state, getters, rootState, rootGetters) => {
  // return groupBy(mockBanners, 'side')
  return groupBy(get(getters, 'currentStation.experience.banners'), 'side');
};
export const bannersLeft = (state, getters, rootState, rootGetters) => {
  const { left } = getters.banners;
  return left;
};
export const bannersRight = (state, getters, rootState, rootGetters) => {
  const { right } = getters.banners;
  return right;
};

// Locale
export const currentStationLocale = (
  state,
  getters,
  rootState,
  rootGetters,
) => {
  return (getters.currentStation && getters.currentStation.locale) || 'en-US';
};
export const locales = (state, getters, rootState, rootGetters) => {
  return getters['entities/Locale/all']();
};
export const currentLocaleAlias = (state, getters, rootState, rootGetters) => {
  return (
    getters.currentStationLocale && getters.currentStationLocale.split('-')[0]
  );
};

// signin || signup
export const accountState = (state, getters, rootState, rootGetters) => {
  if (!rootState.route) return;
  const name = rootState.route.meta.realName;
  return ['signin', 'signup'].includes(name) ? name : undefined;
};
export const reviewingGame = (state, getters, rootState, rootGetters) => {
  const id = state.reviewingGameId;
  return rootGetters['entities/Game'](id);
};

// callHelp
export const hasCalledHelp = (state, getters, rootState, rootGetters) => {
  return getters.currentStation && getters.currentStation.calling;
};
export const currentBookingTime = (state, getters, rootState, rootGetters) => {
  const { bookingTimes, currentBookingTimeId } = state;
  return (
    bookingTimes &&
    currentBookingTimeId &&
    bookingTimes.find(({ id }) => currentBookingTimeId === id)
  );
};
export const currentBooking = (state, getters, rootState, rootGetters) => {
  const { currentBookingTime } = getters;
  return currentBookingTime && currentBookingTime.booking;
};
export const currentBookingId = (state, getters, rootState, rootGetters) => {
  return state.currentBookingTimeId;
};
export const endTime = (state, getters, rootState, rootGetters) => {
  const { currentBookingTime } = getters;
  if (!currentBookingTime) return;
  const { endTime } = currentBookingTime;
  return endTime;
};
export const startTime = (state, getters, rootState, rootGetters) => {
  const { currentBookingTime } = getters;
  if (!currentBookingTime) return;
  const { pausedAt, startTime } = currentBookingTime;
  return startTime || pausedAt;
};
export const remainingTime = (state, getters, rootState, rootGetters) => {
  const { currentBookingTime, currentTime } = getters;
  if (!currentBookingTime) return null;
  const { pausedDuration, endTime } = currentBookingTime;
  if (pausedDuration) {
    return pausedDuration * 1000; // ms
  } else {
    return moment(endTime).diff(moment(currentTime));
  }
};

export const timerStatus = (state, getters, rootState, rootGetters) => {
  const { currentBookingTime, currentStation, safetyMode } = getters;
  if (!safetyMode && !state.bookingTimes) return null;
  if (safetyMode) {
    return 'offline';
  } else if (currentStation && !currentStation.timerEnabled) {
    return 'infinite';
  } else if (state.previousBooking && !currentBookingTime) {
    return 'expired';
  } else if (!currentBookingTime) {
    return 'disabled';
  } else if (currentBookingTime.pausedAt) {
    return 'paused';
  } else {
    return 'active';
  }
};
export const canStart = (state, getters, rootState, rootGetters) => {
  const { timerStatus } = getters;
  return !(timerStatus === 'disabled' || timerStatus === 'expired');
};
export const canSeeGames = (state, getters, rootState, rootGetters) => {
  const { currentStation, canStart } = getters;
  if (!currentStation) return;
  return canStart || currentStation.launcherContentPreviewEnabled;
};

export const disableTimer = (state, getters, rootState, rootGetters) => {
  return !getters.currentBookingTime;
};
export const hasExpired = (state, getters, rootState, rootGetters) => {
  return getters.timerStatus === 'expired';
};

// i18n
export const fetchingDataForNewLocale = (
  state,
  getters,
  rootState,
  rootGetters,
) => {
  const loading = state.loadings.changeLocale;
  return loading;
};

// app global loading
export const appGlobalLoading = (state, getters, rootState, rootGetters) => {
  return state.loadings.initApp;
};

// routes
export const disableFilter = (state, getters, rootState, rootGetters) => {
  if (!rootState.route) return;
  return (
    rootState.route.meta.realName === 'games-search' ||
    rootState.route.meta.realName === 'games-show' ||
    getters.safetyMode
  );
};
export const disableSearch = (state, getters, rootState, rootGetters) => {
  if (!rootState.route) return;
  return rootState.route.meta.realName === 'games-show' || getters.safetyMode;
};

export const safetyMode = (state, getters, rootState, rootGetters) => {
  return (
    state.isRecoveringFromSafetyMode ||
    (state.isAppInitialized &&
      getters.currentStation &&
      getters.currentStation.safetyMode)
  );
};

// session
export const currentCustomer = (state, getters, rootState, rootGetters) => {
  const { currentBooking } = getters;
  return currentBooking && currentBooking.host;
};
export const sessionData = (state, getters, rootState, rootGetters) => {
  const { currentStation, currentBooking, currentCustomer } = getters;
  if (!currentStation) return;
  const {
    idle,
    // overlay // disable overlay tracking for now (see DEV-1469)
    runningId,
    runningType,
  } = state.appState;

  const data = {
    runningId,
    runningType,
    idle,
    // overlay,
    booking: { id: currentBooking && currentBooking.id },
    station: { id: currentStation.id },
    customer: { id: currentCustomer && currentCustomer.id },
  };
  return data;
};
export const sessionDataForImpulse = (state, getters, rootState, rootGetters) => {
  const { currentStation, currentBooking, currentCustomer } = getters;
  if (!currentStation) return;
  const {
    idle,
    overlay,
    runningId,
    runningType,
    type,
    game,
    preset,
    ownership,
    license,
  } = state.appState;

  const data = {
    runningId,
    runningType,
    type,
    idle,
    game,
    preset,
    ownership,
    license,
    overlay,
    booking: { id: currentBooking && currentBooking.id },
    station: { id: currentStation.id },
    customer: { id: currentCustomer && currentCustomer.id },
  };
  return data;
};
